export default __webpack_public_path__ + "static/media/046-teapot.c369f2e8.svg";